<template>
  <el-dialog
    :title="$t('feedback.title')"
    :visible.sync="visible"
    width="800px"
    class="feedback-dialog"
    :before-close="handleClose"
  >
    <div class="feedback-body">
      <div class="greeting">{{ $t('feedback.greeting') }}</div>
      <div class="content">
        <p>{{ $t('feedback.content1') }}</p>
        <p>{{ $t('feedback.content2') }}</p>
        <p>{{ $t('feedback.content3') }}</p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleEnter" class="enter-btn">{{ $t('feedback.enterBtn') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleEnter() {
      this.$emit('enter');
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 12px;
  max-width: 90%;
  .el-dialog__header {
    padding: 24px 24px 12px;
    border-bottom: 1px solid #E5E5E5;
    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: #0A0A0A;
    }
    .el-dialog__headerbtn {
      top: 24px;
      right: 24px;
      font-size: 24px;
      .el-dialog__close {
        color: #999;
        &:hover {
          color: rgb(239, 129, 77);
        }
      }
    }
  }
  .el-dialog__body {
    padding: 32px 40px;
  }
  .el-dialog__footer {
    padding: 0 40px 40px;
    text-align: center;
  }
}

.feedback-body {
  text-align: left;
  .greeting {
    font-size: 18px;
    font-weight: 600;
    color: #0A0A0A;
    margin-bottom: 16px;
  }
  .content {
    font-size: 16px;
    line-height: 1.8;
    color: #404040;
    p {
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.enter-btn {
  width: 280px;
  height: 48px;
  background: rgb(239, 129, 77);
  border-color: rgb(239, 129, 77);
  border-radius: 4px;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  transition: all 0.3s;
  &:hover, &:focus {
    background: rgb(239, 129, 77);
    border-color: rgb(239, 129, 77);
    color: #fff;
    opacity: 0.9;
  }
}

@media screen and (max-width: 850px) {
  ::v-deep .el-dialog {
    width: 90% !important;
    .el-dialog__header {
      padding: 16px 16px 8px;
      .el-dialog__title {
        font-size: 18px;
      }
      .el-dialog__headerbtn {
        top: 16px;
        right: 16px;
      }
    }
    .el-dialog__body {
      padding: 24px 16px;
    }
    .el-dialog__footer {
      padding: 0 16px 32px;
    }
  }
  .feedback-body {
    .greeting {
      font-size: 16px;
    }
    .content {
      font-size: 14px;
      line-height: 1.6;
    }
  }
  .enter-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
  }
}
</style>
